"use client";
import { FilteredProducts } from "../components/search/filtered-products";
import { SearchByTopicsProductList } from "../../use-cases/contracts/Product";
import { Topic as TTopic } from "../../use-cases/contracts/Topic";
import { Filter } from "../components/search";
import { useEffect, useState } from "react";
import { loadTopicData } from "~/use-cases/topic.server";
import { useInView } from "react-intersection-observer";
import Spinner from "~/ui/components/aplia/Spinner";

export default function Topic({
  data,
  path,
}: {
  path: string;
  data: SearchByTopicsProductList & {
    topic?: TTopic;
  };
}) {
  const { products, topics, topic } = data;
  let topicName = topic?.name || topic?.path;
  const [scrollTrigger, isInView] = useInView();
  const [allProducts, setAllProducts] = useState(products);
  const [pagination, setPagination] = useState({
    isLoading: false,
    hasNextPage: data.pageInfo.hasNextPage,
    endCursor: data.pageInfo.endCursor,
  });

  async function loadMorePosts() {
    setPagination({ ...pagination, isLoading: true });
    const res = await loadTopicData({
      path,
      endCursor: pagination.endCursor,
    });
    setAllProducts((oldProducts) => [...oldProducts, ...res.products]);
    setPagination({
      endCursor: res.pageInfo.endCursor,
      hasNextPage: res.pageInfo.hasNextPage,
      isLoading: false,
    });
  }

  useEffect(() => {
    if (isInView && pagination.hasNextPage && !pagination.isLoading) {
      loadMorePosts();
    }
  }, [isInView, pagination]);

  return (
    <div className="container 2xl mx-auto px-6 mt-10">
      <h1 className="font-bold text-4xl">{topicName}</h1>
      <FilteredProducts initialProducts={allProducts} />

      <div className="text-center py-10">
        {pagination.isLoading && <Spinner />}

        {pagination.hasNextPage && (
          <button
            ref={scrollTrigger}
            disabled={pagination.isLoading}
            type="button"
            className="btn inline-block"
            onClick={loadMorePosts}
          >
            {pagination.isLoading
              ? "Laster inn flere produkter"
              : "Last inn flere prdukter"}
          </button>
        )}
      </div>
    </div>
  );
}
